export default __webpack_public_path__ + "img/5ad23b8f89c6c88af71cbf50150aa8ba.png";